import AppChannel from 'modules/channels/App';

export const GOOGLE_SIGN_IN = 'google';

const formDataToRequest = formData => {
    const data = {
        accountSourceApp: 'laruchequiditoui',
        accountSourcePage: 'home',
        address: { city: formData.cityId },
        email: formData.email,
        firstName: formData.firstName,
        hasAcceptedTOS: formData.hasAcceptedTOS,
        lastName: formData.lastName,
        plainPassword: formData.plainPassword,
    };

    return data;
};

export const onSuccess = ({
    email,
    password,
    assemblyId,
    authType,
    onCallbackFail,
    onCallbackSucceed,
}) => {
    if (assemblyId) {
        AppChannel.vent.trigger('assembly:join:submit', assemblyId);
        AppChannel.vent.trigger('analytics:assembly:join', assemblyId);
    }
    let options = {};
    if (authType !== GOOGLE_SIGN_IN) {
        options = {
            username: email,
            password,
            // auto remember the user when registering
            remember: true,
            hasRegistered: true,
            onCallbackFail,
            onCallbackSucceed,
        };
    }
    AppChannel.vent.trigger('register');
    AppChannel.commands.execute('login', options);
};

export default formDataToRequest;
